













































import { defineComponent, type PropType } from "vue-demi";
import type { Product } from "@constructor/shared-entity/type";
import CartTool from "../shared/CartTool/CartTool.vue";
import type { UserCartItem } from "../../type/UserCart";
import GGPrice from "./GGPrice.vue";
import ProductDiscountMarker from "../shared/ProductDiscountMarker.vue";

export default defineComponent({
  name: "GGProductFlashGrid",
  components: {
    GGPrice,
    ProductDiscountMarker,
    CartTool,
  },
  props: {
    items: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    userCartItem: {
      type: Object as PropType<UserCartItem | null>,
      default: null,
    },
  },
  computed: {
    itemsCount() {
      return this.items.length;
    },
  },
});
